var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMattersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3021",
    "data-name": "Rectangle 3021",
    width: 17,
    height: 15,
    transform: "translate(0 0)",
    fill: "#2e728c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9706",
    "data-name": "Group 9706",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9705",
    "data-name": "Group 9705",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26715",
    "data-name": "Path 26715",
    d: "M16.393,15H.911A1,1,0,0,1,0,13.929a1,1,0,0,1,.911-1.071H16.393a1,1,0,0,1,.911,1.071A1,1,0,0,1,16.393,15M11.384,8.571H.911A1,1,0,0,1,0,7.5,1,1,0,0,1,.911,6.429H11.384A1,1,0,0,1,12.295,7.5a1,1,0,0,1-.911,1.071m5.009-6.429H.911A1,1,0,0,1,0,1.071,1,1,0,0,1,.911,0H16.393A1,1,0,0,1,17.3,1.071a1,1,0,0,1-.911,1.071",
    transform: "translate(0 0)",
    fill: "#2e728c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMattersIcon);
export default __webpack_public_path__ + "static/media/Matters_icon.ce6d03e89508f2a0e19a1f7b9fbfb58e.svg";
export { ForwardRef as ReactComponent };